import { render } from "./TextAvatarSizeRoundedCircleExample.vue?vue&type=template&id=07c6315c&ts=true"
import script from "./TextAvatarSizeRoundedCircleExample.vue?vue&type=script&lang=ts"
export * from "./TextAvatarSizeRoundedCircleExample.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__